<template>
  <block class="product-detail-gains-block"
         title="学员心声"
         :more="showMore"
         more-desc="查看全部"
         @click-more="handleShowMore"
  >
    <gain-list :list="list" />
  </block>
</template>

<script>
  import Block from '@/components/Block';
  import GainList from '@/pages/StudentGains/components/StudentGainsList';

  export default {
    name: 'ProductDetailGainsBlock',
    components: {
      Block,
      GainList,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      showMore: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      handleShowMore() {
        this.$emit('click-more');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-gains-block {
    border-bottom: @size-extra-small solid @background-color-base;
  }

</style>
